import { Transaction } from '../../entities/Transaction'
import { TransactionRequests } from '@/services/transaction.requests'
const transactionService = new TransactionRequests()

import Vue from 'vue'

const state = {
  read: null,
  edited: null
}
const getters = {}

const actions = {
  get ({}, { id }) {
    return new Promise((resolve, reject) => {
      transactionService.get(id).then((transaction) => {
        resolve(transaction)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { accountId, currencyId, amount, type }) {
    return new Promise(async (resolve, reject) => {
      var read = state.read ? state.read.transaction : new Transaction()
      commit('setField', { field: 'accountId', value: accountId })
      commit('setField', { field: 'currencyId', value: currencyId })
      commit('setField', { field: 'amount', value: amount })
      commit('setField', { field: 'type', value: type })
      transactionService.save(read.serialize(state.edited)).then((id) => {
        commit('resetEdited')
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, transaction) {
    state.read = transaction
    if (!transaction) {
      state.associations = null
    }
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
